import { Routes } from '@angular/router';
import { ProfileInfoComponent } from './containers/profile-info/profile-info.component';
import { MyListingComponent } from './containers/my-listing/my-listing.component';
import { MyListingResolver } from './my-listing.resolver';
import { DetailsComponent } from './containers/details/details.component';
import { IsLisitngIdValidGuard } from './guards/is-lisitng-id-valid.guard';
import { ListingDetailsResolver } from '../listing/resolvers/listing-details.resolver';
import { StripeSettingsComponent } from './containers/stripe-settings/stripe-settings.component';
import { PreferenceComponent } from './containers/preference/preference.component';
import { SecurityComponent } from './containers/security/security.component';
import { ProfileComponent } from './profile.component';

export const profileRoutes: Routes = [
    {
        path: '',
        component: ProfileComponent,
        children: [
            {
                path: '', component: ProfileInfoComponent
            },
            {
                path: 'my-listing',
                component: MyListingComponent,
                resolve: { listings: MyListingResolver },
                children: [
                    {
                        path: ':listingID',
                        component: DetailsComponent,
                        canActivate: [IsLisitngIdValidGuard],
                        resolve: { listingDetails: ListingDetailsResolver }
                    }
                ]
            },
            {
                path: 'pay-in-out-method',
                component: StripeSettingsComponent
            },
            {
                path: 'preference',
                component: PreferenceComponent
            },
            {
                path: 'security',
                component: SecurityComponent
            }
        ]
    }
];
